<template>
  <footer
    class="flex items-end bg-avu-brown px-[26px] pb-6 pt-[30px] font-avuText text-avu-gray min-[834px]:px-[55px] min-[834px]:pt-[122px] min-[1200px]:h-[32vw] min-[1200px]:pb-[17px] min-[1200px]:pt-[425px] xl:h-[27.92vw] min-[1300px]:px-[67px] 2xl:h-[39vw]"
  >
    <div class="flex w-full flex-col min-[1200px]:gap-[68px]">
      <div
        class="flex flex-col items-start gap-[178px] sm:gap-32 min-[1200px]:flex-row min-[1200px]:items-center min-[1200px]:justify-between"
      >
        <div
          class="grid h-[12vw] grid-cols-5 gap-7 sm:gap-10 min-[834px]:h-[10vw] min-[900px]:h-[7vw] min-[930px]:h-[8vw]"
        >
          <LIcon
            class="w-[12vw] min-[834px]:w-[10vw] min-[900px]:w-[7vw] min-[930px]:w-[8vw]"
          />
          <AIcon
            class="w-[12vw] min-[834px]:w-[10vw] min-[900px]:w-[7vw] min-[930px]:w-[8vw]"
          />
          <RIcon
            class="w-[12vw] min-[834px]:w-[10vw] min-[900px]:w-[7vw] min-[930px]:w-[8vw]"
          />
          <GIcon
            class="w-[12vw] min-[834px]:w-[10vw] min-[900px]:w-[7vw] min-[930px]:w-[8vw]"
          />
          <EIcon
            class="w-[12vw] min-[834px]:w-[10vw] min-[900px]:w-[7vw] min-[930px]:w-[8vw]"
          />
        </div>

        <div
          class="mb-[52px] flex flex-col text-[30px]/10 min-[1200px]:mb-0 min-[1200px]:gap-4 min-[1200px]:text-end min-[1250px]:text-[32px]/8"
        >
          <a
            v-for="social in data?.social_networks"
            :key="social.type"
            :href="social.url"
            target="_blank"
            class="relative z-40 uppercase"
          >
            {{ social.type }}
          </a>
        </div>
      </div>

      <div
        class="-mx-[26px] -mb-6 -mt-[18px] flex w-auto flex-col gap-[18px] bg-avu-black px-[26px] pb-6 pt-[18px] min-[834px]:-mx-[55px] min-[834px]:px-[55px] min-[1200px]:mb-0 min-[1200px]:flex-row min-[1200px]:items-end min-[1200px]:justify-between min-[1200px]:gap-0 min-[1200px]:bg-transparent"
      >
        <div
          class="flex w-full flex-col gap-4 text-[10px] sm:w-2/3 min-[1200px]:w-fit min-[1200px]:gap-0 min-[1200px]:text-nowrap"
        >
          <p
            v-for="(claim, index) in data?.claims"
            :key="index"
            class="w-full text-wrap"
          >
            {{ claim }}
          </p>
        </div>

        <span class="w-fit text-nowrap text-[10px]">
          © LARGE {{ dayjs(new Date()).format("YYYY") }} | DESIGNED BY
          <NuxtLink
            to="https://www.brainzstudios.cz/"
            target="_blank"
            class="relative z-40"
          >
            BRAINZ STUDIOS
          </NuxtLink>
        </span>
      </div>
    </div>
  </footer>
</template>

<script setup>
  import dayjs from "dayjs";

  const data = ref([]);

  const { data: queryData } = await usePersistedFetch("footer");

  watchEffect(() => {
    data.value = queryData.value?.settings?.footer;
  });
</script>
